@if (user) {
<nav
  class="navbar-default navbar-static-side"
  role="navigation"
  [class.mobile-open]="navState.mobileOpen()"
  [class.collapsed]="navState.collapsed()"
  [class.theme-inverted]="navState.inverted()"
>
  <div class="sidebar-collapse">
    <ul class="nav" id="side-menu">
      <li class="nav-header">
        <button
          type="button"
          class="sidebar-close-btn"
          (click)="navState.closeMobile()"
          aria-label="Fermer le menu"
        >
          <i class="far fa-times"></i>
        </button>
        <div class="profile-element" dropdown>
          <img [src]="getLogo()" alt="image" class="sidebar-logo" />
        </div>
        <div class="logo-element">MIR</div>
      </li>
      <li>
        <a
          [routerLink]="['/']"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}"
          appCloseMenuOnClick
          data-tooltip="Accueil"
        >
          <i class="far fa-home fa-fw"></i>
          <span class="nav-label"> Accueil</span>
        </a>
      </li>
      <li class="nav-group" [class.open]="navState.isGroupOpen('profil')">
        <a (click)="navState.onGroupClick('profil')" role="button" title="Profil" data-tooltip="Mon profil">
          <i class="far fa-user-alt fa-fw"></i>
          <span class="nav-label"> Mon profil</span>
          <i class="fas fa-chevron-down nav-group-arrow"></i>
        </a>
        <ul class="nav nav-second-level">
          @if (version?.isAuthorized('CONVOCATION') && user.isAuthorized('OP_CONVOCATION')) {
          <li>
            <a [routerLink]="['/convocations']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="fal fa-inbox-in"></i> Mes Convocations
            </a>
          </li>
          }
          @if (version?.isAuthorized('FORMULAIRES')) {
            @if (user.isAuthorized('OP_FORM_READ')) {
            <li>
              <a [routerLink]="['/formulaires/absence']" routerLinkActive="active" appCloseMenuOnClick>
                <i class="fas fa-bullhorn"></i> Excuses et absences
              </a>
            </li>
            }
            @if (user.isAuthorized('OP_FORM_CREATE')) {
            <li>
              <a [routerLink]="['/formulaires/new']" routerLinkActive="active" appCloseMenuOnClick>
                <i class="fas fa-file-signature"></i> Heures à solder
              </a>
            </li>
            }
            <li>
              @if (user.isAuthorized('OP_FORM_CREATE')) {
              <a [routerLink]="['/formulaires']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" appCloseMenuOnClick>
                <i class="far fa-star"></i> Mes heures à solder
              </a>
              }
            </li>
          }
          @if (version?.isAuthorized('CARTE_LEGITIMATION')) {
          <li>
            <a [routerLink]="['/carte-legitimation']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="far fa-gift-card"></i> Carte Légitimation
            </a>
          </li>
          }
          @if (version.sdis.ecaPortal) {
          <li>
            <a
              appCloseMenuOnClick
              href="https://mypassword.118-vaud.ch/"
              target="_blank"
              title="Changement du mot de passe ECA"
            >
              <i class="fas fa-key fa-fw"></i>
              Changer mot de passe
            </a>
          </li>
          }
        </ul>
      </li>
      @if (user.isAuthorized('ROLE_SAPEUR')) {
      <li class="nav-group" [class.open]="navState.isGroupOpen('sdis')">
        <a (click)="navState.onGroupClick('sdis')" role="button" title="Convocation" data-tooltip="Mon SDIS">
          <i class="far fa-fire fa-fw"></i>
          <span class="nav-label"> Mon SDIS</span>
          <i class="fas fa-chevron-down nav-group-arrow"></i>
        </a>
        <ul class="nav nav-second-level">
          @if (version?.isAuthorized('ANNOUNCE')) {
          <li>
            <a [routerLink]="['/annonce']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="fal fa-bell fa-fw"></i> Annonces
            </a>
          </li>
          }
          @if (version?.isAuthorized('ANNUAIRE') && user.isAuthorized('OP_ANNUAIRE')) {
          <li>
            <a [routerLink]="['/annuaire']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="fal fa-users fa-fw"></i> Annuaire
            </a>
          </li>
          }
          @if (version?.isAuthorized('MSGR') && user.isAuthorized('OP_MSGR')) {
          <li>
            <a [routerLink]="['/msgr']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="fal fa-pager fa-fw"></i> CTA
            </a>
          </li>
          }
          @if (version?.isAuthorized('MATERIEL') && user.isAuthorized('OP_BOOKING_READ')) {
          <li>
            <a
              [queryParams]="{'ecawin': true}"
              [routerLink]="['/booking/calendar']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored'}"
              appCloseMenuOnClick
            >
              <i class="fas fa-calendar-alt fa-fw"></i> Calendrier SDIS
            </a>
          </li>
          }
          @if (version?.isAuthorized('STATISTICS') && user.isAuthorized('OP_WEBEASY_REPORTS')) {
          <li class="nav-subgroup" [class.open]="navState.isSubgroupOpen('interventions')" title="Statistiques">
            <a (click)="navState.toggleSubgroup('interventions')" role="button" class="nav-third-level-label">
              <i class="fas fa-chart-line fa-fw"></i> Interventions
              <i class="fas fa-chevron-down nav-group-arrow"></i>
            </a>
            <ul class="nav nav-third-level">
              @if (user.isAuthorized('OP_WEBEASY_REPORTS')) {
              <li>
                @if (user.nip) {
                <a [routerLink]="['/statistics/fireman', user.nip]" routerLinkActive="active" appCloseMenuOnClick
                  ><i class="far fa-user-chart"></i> Mes interventions</a
                >
                }
              </li>
              }
              @if (user.isAuthorized('OP_WEBEASY_REPORTS')) {
              <li>
                <a [routerLink]="['/statistics']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" appCloseMenuOnClick
                  ><i class="far fa-chart-line"></i> Rapports</a
                >
              </li>
              }
              @if (user.isAuthorized('OP_WEBEASY_HALL_OF_FAME')) {
              <li>
                <a [routerLink]="['/statistics/hall-of-fame']" routerLinkActive="active" appCloseMenuOnClick
                  ><i class="far fa-chart-bar"></i> Statistiques</a
                >
              </li>
              }
            </ul>
          </li>
          }
        </ul>
      </li>
      }
      @if (version?.isAuthorized('ROULAGE') && user.isAuthorized('OP_BOOKING_READ')) {
      <li class="nav-group" [class.open]="navState.isGroupOpen('roulages')">
        <a (click)="navState.onGroupClick('roulages')" role="button" title="Roulage" data-tooltip="Roulages">
          <i class="far fa-steering-wheel fa-fw"></i>
          <span class="nav-label"> Roulages</span>
          <i class="fas fa-chevron-down nav-group-arrow"></i>
        </a>
        <ul class="nav nav-second-level">
          @if (user.isAuthorized('OP_BOOKING_CREATE')) {
          <li>
            <a [routerLink]="['/roulage/planifier']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="fas fa-calendar-plus"></i> Planifier un roulage
            </a>
          </li>
          }
          @if (user.isAuthorized('OP_BOOKING_CREATE')) {
          <li>
            <a [routerLink]="['/roulage/saisir-rapport']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="fas fa-file-signature"></i> Saisir rapport
            </a>
          </li>
          }
          <li>
            @if (user.isAuthorized('OP_BOOKING_CREATE')) {
            <a [routerLink]="['/roulage/mes-roulages']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="far fa-star"></i> Mes roulages
            </a>
            }
          </li>
          <li>
            <a [routerLink]="['/roulage/rapports-sdis']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="far fa-list fa-fw"></i> Roulages SDIS
            </a>
          </li>
          @if (user.isAuthorized('OP_ROULAGE_ADMIN')) {
          <li>
            <a [routerLink]="['/roulage/formation-sdis']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="fas fa-tachometer-alt"></i> Formations
            </a>
          </li>
          }
        </ul>
      </li>
      }
      @if (version?.isAuthorized('MATERIEL') && user.isAuthorized('OP_BOOKING_READ')) {
      <li class="nav-group" [class.open]="navState.isGroupOpen('materiel')">
        <a (click)="navState.onGroupClick('materiel')" role="button" title="Commandes matériel" data-tooltip="Matériel">
          <i class="far fa-truck fa-fw"></i>
          <span class="nav-label"> Matériel</span>
          <i class="fas fa-chevron-down nav-group-arrow"></i>
        </a>
        <ul class="nav nav-second-level">
          @if (user.isAuthorized('OP_BOOKING_CREATE')) {
          <li>
            <a [routerLink]="['/booking/new']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="fal fa-plus fa-fw"></i> Créer commande
            </a>
          </li>
          }
          <li>
            @if (user.isAuthorized('OP_FAILURE_CREATE')) {
            <a [routerLink]="['/failure/new']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="far fa-comment-alt-exclamation fa-fw"></i>
              Annonce matériel
            </a>
            }
          </li>
          <li>
            @if (user.isAuthorized('OP_BOOKING_CREATE')) {
            <a [routerLink]="['/booking/my']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="far fa-star fa-fw"></i> Mes commandes
            </a>
            }
          </li>
          <li>
            <a [routerLink]="['/booking/all']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="far fa-list fa-fw"></i> Toutes les commandes
            </a>
          </li>
          <li>
            <a
              [queryParams]="{'events': true}"
              [routerLink]="['/booking/calendar']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored'}"
              appCloseMenuOnClick
            >
              <i class="far fa-calendar-alt fa-fw"></i> Calendrier
            </a>
          </li>
          @if (user.isBookingValidator()) {
          <li>
            <a [routerLink]="['/booking/settings/resources']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="far fa-truck fa-fw"></i> Matériels
            </a>
          </li>
          }
          @if (user.isBookingValidator()) {
          <li>
            <a [routerLink]="['/booking/settings/types']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="far fa-palette fa-fw"></i> Types et couleurs
            </a>
          </li>
          }
        </ul>
      </li>
      }
      @if (version?.isAuthorized('APR') && user.isAuthorized('OP_APR_READ')) {
      <li class="nav-group" [class.open]="navState.isGroupOpen('apr')" title="APR">
        <a (click)="navState.onGroupClick('apr')" role="button" title="APR" data-tooltip="APR">
          <i class="far fa-fire-extinguisher fa-fw"></i>
          <span class="nav-label"> APR</span>
          <i class="fas fa-chevron-down nav-group-arrow"></i>
        </a>
        <ul class="nav nav-second-level">
          <li>
            <a [routerLink]="['/apr']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" appCloseMenuOnClick
              ><i class="far fa-table"></i> Tableau</a
            >
          </li>
          <li>
            <a [routerLink]="['/apr/journal']" routerLinkActive="active" appCloseMenuOnClick
              ><i class="far fa-list"></i> Journal</a
            >
          </li>
          @if (user.isAuthorized('OP_APR_WRITE')) {
          <li>
            <a [routerLink]="['/apr/materials']" routerLinkActive="active" appCloseMenuOnClick
              ><i class="far fa-wrench"></i> Matériels</a
            >
          </li>
          }
          @if (user.isAuthorized('OP_APR_WRITE')) {
          <li>
            <a [routerLink]="['/apr/containers']" routerLinkActive="active" appCloseMenuOnClick
              ><i class="far fa-map-marker"></i> Emplacements</a
            >
          </li>
          }
        </ul>
      </li>
      }
      @if (user.isAuthorized('OP_USERS_MANAGEMENT') || user.isAuthorized('OP_ANNOUNCE_ADMIN')) {
      <li class="nav-group" [class.open]="navState.isGroupOpen('administration')">
        <a (click)="navState.onGroupClick('administration')" role="button" title="Administration" data-tooltip="Administration">
          <i class="fas fa-tools fa-fw"></i>
          <span class="nav-label"> Administration</span>
          <i class="fas fa-chevron-down nav-group-arrow"></i>
        </a>
        <ul class="nav nav-second-level">
          @if (user.isAuthorized('OP_ANNOUNCE_ADMIN')) {
          <li>
            <a [routerLink]="['/annonce/admin']" routerLinkActive="active" appCloseMenuOnClick
              ><i class="far fa-envelope"></i> Gérer les annonces</a
            >
          </li>
          }
          @if (user.isAuthorized('OP_USERS_MANAGEMENT')) {
          <li class="nav-subgroup" [class.open]="navState.isSubgroupOpen('utilisateurs')" title="Utilisateurs, tags et droits">
            <a (click)="navState.toggleSubgroup('utilisateurs')" role="button" class="nav-third-level-label">
              <i class="fas fa-users"></i> Utilisateurs
              <i class="fas fa-chevron-down nav-group-arrow"></i>
            </a>
            <ul class="nav nav-third-level">
              <li>
                <a [routerLink]="['/users']" routerLinkActive="active" appCloseMenuOnClick
                  ><i class="far fa-users"></i> Utilisateurs</a
                >
              </li>
              @if (user.isAuthorized('OP_ANNOUNCE_ADMIN')) {
              <li>
                <a [routerLink]="['/tags']" routerLinkActive="active" appCloseMenuOnClick>
                  <em class="fal fa-user-tag"></em> Tags
                </a>
              </li>
              }
              <li>
                <a [routerLink]="['/permissions']" routerLinkActive="active" appCloseMenuOnClick
                  ><i class="fas fa-shield-alt"></i> Rôles et droits</a
                >
              </li>
            </ul>
          </li>
          }
          @if (version?.isAuthorized('CONVOCATION') && user.isAuthorized('OP_CONVOCATION_ADMIN')) {
          <li>
            <a [routerLink]="['/convocations/ecawin']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="far fa-calendar-plus"></i> Cours & Exercices
            </a>
          </li>
          }
          @if (version?.isAuthorized('FORMULAIRES') && user.isAuthorized('OP_FORM_ADMIN')) {
          <li>
            <a [routerLink]="['/formulaires/rapports']" routerLinkActive="active" appCloseMenuOnClick>
              <i class="far fa-list"></i> Gestion des heures non soldées
            </a>
          </li>
          }
          <li>
            @if (user.isRoot()) {
            <a [routerLink]="['/sqrs-dashboard']" routerLinkActive="active" appCloseMenuOnClick
              ><i class="far fa-debug"></i> Sqrs dashboard</a
            >
            }
          </li>
        </ul>
      </li>
      }
      @if (user.isAuthorized('ROLE_SAPEUR') && version?.isAuthorized('MIRDOCS')) {
      <li>
        <a [routerLink]="['/mirdocs']" routerLinkActive="active" appCloseMenuOnClick data-tooltip="Mirdocs">
          <i class="fas fa-disc-drive fa-fw"></i>
          <span class="nav-label"> Mirdocs</span>
        </a>
      </li>
      }
      <li class="nav-group" [class.open]="navState.isGroupOpen('liens')">
        <a (click)="navState.onGroupClick('liens')" role="button" title="Liens" data-tooltip="Liens">
          <i class="far fa-link fa-fw"></i>
          <span class="nav-label"> Liens</span>
          <i class="fas fa-chevron-down nav-group-arrow"></i>
        </a>
        <ul class="nav nav-second-level">
          <li>
            <a
              appCloseMenuOnClick
              href="{{version.sdis.publicWebSite}}"
              target="_blank"
              title="{{version.sdis.name}}"
            >
              <i class="fas fa-external-link-square-alt fa-fw"></i>
              {{version.sdis.name}}
            </a>
          </li>
          @if (version.sdis.ecaPortal) {
          <li>
            <a
              appCloseMenuOnClick
              href="{{version.sdis.ecaPortal}}"
              target="_blank"
              title="Portail ECA"
            >
              <i class="fas fa-external-link-square-alt fa-fw"></i>
              Portail ECA
            </a>
          </li>
          }
          <li>
            <a
              appCloseMenuOnClick
              href="https://storage.118-vaud.ch/login"
              target="_blank"
              title="ECABOX"
            >
              <i class="fas fa-external-link-square-alt fa-fw"></i>
              ECABOX
            </a>
          </li>
          @if (version.sdis.customLinks) {
            @for (link of version.sdis.customLinks; track link) {
            <li>
              <a
                appCloseMenuOnClick
                href="{{link.href}}"
                target="_blank"
                [title]="link.title"
              >
                <i class="fas fa-external-link-square-alt fa-fw"></i>
                {{link.title}}
              </a>
            </li>
            }
          }
        </ul>
      </li>
      <li>
        <a
          role="button"
          class="theme-toggle-item"
          (click)="navState.toggleInverted()"
          [attr.aria-pressed]="navState.inverted()"
          title="Changer de thème"
        >
          <i class="fal fa-palette fa-fw"></i>
          <span class="nav-label">Thème</span>
          <span class="theme-toggle-switch" [class.on]="navState.inverted()">
            <span class="theme-toggle-knob"></span>
          </span>
        </a>
      </li>
    </ul>
  </div>
</nav>
<div class="sidebar-backdrop" [class.visible]="navState.mobileOpen()" (click)="navState.closeMobile()"></div>
}
